export default {
  filterBy: (array, filters) => {
    const filterKeys = Object.keys(filters)
    return array.filter((item) => {
      return filterKeys.every((key) => {
        if (!filters[key].length) {
          return true
        }
        return filters[key].includes(item[key])
      })
    })
  },

  sortList: (arr, listItem, sortDirection) => {
    arr.sort((a, b) => {
      if (sortDirection === 'ASC') {
        if (a[listItem] < b[listItem]) {
          return -1
        }
        if (a[listItem] > b[listItem]) {
          return 1
        }
      }

      if (sortDirection === 'DESC') {
        if (b[listItem] < a[listItem]) {
          return -1
        }
        if (b[listItem] > a[listItem]) {
          return 1
        }
      }
      return 0
    })
  },

  countTotal: (counts) => {
    return counts?.reduce((a, b) => a + b, 0).toFixed()
  },

  countByProp: (arr, classifier) => {
    return arr?.reduce((counter, item) => {
      const p = (classifier || String)(item)
      counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
      return counter
    }, {})
  },

  sortList: (arr, { listItemKey: listItem }, sortDirection) => {
    arr.sort((a, b) => {
      if (sortDirection === 'ASC') {
        if (a[listItem] < b[listItem]) {
          return -1;
        }
        if (a[listItem] > b[listItem]) {
          return 1;
        }
      }
  
      if (sortDirection === 'DESC') {
        if (b[listItem] < a[listItem]) {
          return -1;
        }
        if (b[listItem] > a[listItem]) {
          return 1;
        }
      }
      return 0;
    });
  }
}
